import React, { useEffect, useState } from 'react';
import Header from '../../componets/header/header';
import Footer from '../../componets/footer/footer';
import courseback from "../../../assets/course-back.jpg";
import { useParams } from 'react-router-dom';
import { GET, POST } from '../../../utils/apicalls';
import { API } from '../../../config/api';
import { App, Button, Col, Form, Input, Modal, Row, Tabs } from 'antd';

// @ts-ignore: CSS side-effect import without declaration file
import './commonCourse.css';
import EligibilityCheckForm from '../eligibilitycheckForm';
import course1 from "../../../assets/course1.webp";
import course2 from "../../../assets/eligibility_check.webp";
import course3 from "../../../assets/course2.webp";
import course4 from "../../../assets/course3.webp";
import defalut from "../../../assets/fixed_mage.png";
import EnrollModal from '../../booking-payment/enrollmentModel';
import why1 from '../../../assets/why1.webp';
import whycfe from '../../../assets/course2.webp';
import FormItem from 'antd/es/form/FormItem';

import CourseDisplayCard from './courseDisplayCard';
function Cfe() {
    const { id } = useParams();
    const [form] = Form.useForm();
    const { notification } = App.useApp();
    const [courseDetails, setCourseDetails] = useState<any>(null);
    const [isLoading, setIsLoading] = useState(false);
    // const [isModalOpen, setIsModalOpen] = useState(false);
    const [activeTab, setActiveTab] = useState('eligibility');
    const [isEligibilityModalOpen, setIsEligibilityModalOpen] = useState(false);
    const [selectedCourseForEnroll, setSelectedCourseForEnroll] = useState<string | number | null>(null);
    const [isModalVisible, setIsModalVisible] = useState(false);
    const submitHandler = async (values: any) => {
        try {
            let obj = {
                name: values.name,
                email: values.email,
                message: values.message,
                phone: values.phone,
                Course_id: Number(id),
            };

            setIsLoading(true);
            const postRequest: any = await POST(API.CREATE_COURSE_ENQUIRY, obj);

            if (postRequest) {
                notification.success({ message: "Message sent successfully!" });
                form.resetFields();
            } else {
                notification.error({ message: "Something went wrong" });
            }
        } catch (error) {
            console.error(error);
            notification.error({
                message: "Something went wrong! Please try again later",
            });
        } finally {
            setIsLoading(false);
        }
    };
    const tabItems = [
        {
            key: 'eligibility',
            label: <div className="tab-label">Eligibility Check</div>,
            children: (
                <div className="tab-content eligibility-tab">
                    <div className="tab-text">
                        <h2>Eligibility Check</h2>
                        <ul>
                            <li>Must be an <strong> ACFE Associate Member </strong></li>
                            <li>Minimum <strong>40 eligibility points</strong> to write the exam
                            </li>
                            <li>Minimum <strong>50 points + 2 years relevant experience </strong> (or approved alternative) to earn
                                certification
                            </li>
                        </ul>

                    </div>
                    <div className="tab-image">
                        <img src={course2} alt="CFE certification India" />
                    </div>
                </div>

            ),
        },
        {
            key: 'exam',
            label: <div className="tab-label">Pattern and Scoring</div>,
            children: (
                <div className="tab-content exam-tab">
                    <div className="tab-text">
                        <ul>
                            <li>
                                <strong>  4 sections</strong> (100 MCQs each)   </li>
                            <ol>
                                <li>Financial Transactions and Fraud Schemes</li>
                                <li>Law</li>
                                <li>Investigation </li>
                                <li> Fraud Prevention & Deterrence</li>
                            </ol>
                            <li> <strong> 2 hours per section </strong> </li>
                            <li><strong>Closed-book </strong>exam </li>
                            <li>Scoring based on ACFE guidelines; retakes allowed per ACFE policy </li>
                        </ul>
                    </div>
                    <div className="tab-image">
                        <img src={course1} alt="CFE certification India" />
                    </div>
                </div>

            ),
        },

        {
            key: 'outcomes',
            label: <div className="tab-label">Career Opportunities</div>,
            children: (
                <div className="tab-content outcomes-tab">
                    <div className="tab-text">
                        <h3>CFE unlocks careers in:</h3>
                        <ul>
                            <li>
                                Fraud Investigation</li>
                            <li>Forensic Accounting</li>
                            <li>Internal Audit & Compliance</li>
                            <li>Risk Management</li>
                            <li>Corporate Security </li>
                            <li>Law Enforcement & Consulting</li>

                        </ul>
                    </div>
                    <div className="tab-image">
                        <img src={course3} alt="CFE certification India" />
                    </div>
                </div>

            ),
        },
        {
            key: 'target-audiance',
            label: <div className="tab-label">CFE Exam Cost</div>,
            children: (
                <div className="tab-content outcomes-tab">
                    <div className="tab-text">
                        <ul>
                            <li>
                                <strong> ACFE Membership Fee</strong>    (varies by region)
                            </li>
                            <li> <strong>Exam Application Fee: </strong> approx. <strong>USD $475 </strong>(subject to change)
                            </li>

                        </ul>
                    </div>
                    <div className="tab-image">
                        <img src={course4} alt=" CFE course Kerala" />
                    </div>
                </div>
            ),
        },


    ];
    useEffect(() => {
        const fetchCourseDetails = async () => {
            setIsLoading(true);
            try {
                const response: any = await GET(`${API.GET_COURSE_BY_ID}${id}`, {});
                setCourseDetails(response?.data);
                console.log("Course Response:", response);
            } catch (error) {
                console.error("Error fetching course details:", error);
            } finally {
                setIsLoading(false);
            }
        };

        if (id) {
            fetchCourseDetails();
        }
    }, [id]);
    const [openSection, setOpenSection] = useState<string | null>(null);

    const toggleSection = (section: string) => {
        setOpenSection(prev => (prev === section ? null : section));
    };

    // Update the showModal function
    const showModal = (courseId: string | number, e: React.MouseEvent) => {
        e.stopPropagation(); // Stop event propagation to prevent navigation
        setSelectedCourseForEnroll(courseId);
        setIsModalVisible(true);
    };

    // Update the handleCloseModal function
    const handleCloseModal = () => {
        setIsModalVisible(false);
        setSelectedCourseForEnroll(null); // Reset selected course when closing
    };
    // const downloadBrochure = () => {
    //     window.open(courseDetails?.course_Brousher, '_blank');
    // };
    const description = courseDetails?.course_description;

    const whycfetexts = [
        "World’s No.1 anti-fraud credential with 95,000+ members.",
        "Top AI-proof career requiring human judgement & investigation skills.",
        "Preferred by Big 4, banks, MNCs, and government agencies.",
        "CFE earn up to 34% higher salaries and move into forensic, risk & compliance roles. ",
        "Quick path: 4 exams | 3 - 4 months.",
    ]


    const whyTexts = [
        "Kerala’s first CFE course provider",
        "Lowest coaching fee in India ",
        "Expert faculty & updated study materials ",
        "Realistic mock exams for guaranteed success ",
        "Full support to become a globally recognized CFE ",
        "Strong Placement History in Big 4’s ",
        "100% Placement Assistance ",
        "Premium Online & Offline Batches-(English & Malayalam) ",
        "Big 4 Alumni as Mentors",

    ];
    return (
        <div>
            <Header />
            <div className="course-page-container">
                <div className="course-hero">
                    <img src={courseback} alt=" CFE course Kerala" className="course-hero-image" />
                    <div className="course-hero-overlay"></div>

                    <div className="course-hero-inner">
                        {/* Left Content */}
                        <div className="course-hero-content left-content">
                            <h1>
                                {isLoading
                                    ? "Loading..."
                                    : courseDetails?.course_title
                                        ?.replace(/\s*\(.*?\)/, "") || "Course Title"}

                                {!isLoading && courseDetails?.course_title?.match(/\(.*?\)/) && (
                                    <h1>
                                        {courseDetails.course_title.match(/\(.*?\)/)?.[0]}
                                    </h1>
                                )}
                            </h1>
                            <i>(Globally Recognized Fraud Investigation Expert )</i>
                            <p>{courseDetails?.course_duration}</p>
                            <p>
                                Earn up to 12+ LPA in just 4 months!  <br />
                                Jobs at Big 4, Banks, MNCs & Risk Consulting Firms
                            </p>

                            <Button
                                className="courseCard-button primary-button"
                                type="primary"
                                onClick={(e) => showModal(id!, e)}
                            >
                                Enroll Now
                            </Button>

                            {isModalVisible && (
                                <EnrollModal
                                    visible={isModalVisible}
                                    onClose={handleCloseModal}
                                    courseId={selectedCourseForEnroll}
                                />
                            )}
                        </div>

                        {/* Right Form */}
                        <div className="course-hero-content right-form">
                            <h2>  Make an Enquiry</h2>
                            <Form
                                form={form}
                                layout="vertical"
                                onFinish={submitHandler}
                                initialValues={{
                                    name: '',
                                    phone: '',
                                    email: '',
                                    message: '',
                                }}
                            >
                                <Row gutter={24}>
                                    <Col xs={24} md={12}>
                                        <Form.Item
                                            label="Name"
                                            name="name"
                                            rules={[{ required: true, message: 'Please enter your name' }]}
                                        >
                                            <Input placeholder="Your Name" />
                                        </Form.Item>
                                    </Col>
                                    <Col xs={24} md={12}>
                                        <Form.Item
                                            label="Phone"
                                            name="phone"
                                            rules={[{ required: true, message: 'Please enter your phone' }]}
                                        >
                                            <Input placeholder="Your phone" />
                                        </Form.Item>
                                    </Col>
                                    <Col xs={24} md={12}>
                                        <Form.Item
                                            label="Email"
                                            name="email"
                                            rules={[{ required: true, message: 'Please enter your email' }]}
                                        >
                                            <Input type="email" placeholder="Email Address" />
                                        </Form.Item>
                                    </Col>
                                    <Col xs={24} md={12}>
                                        <Form.Item
                                            label="Message"
                                            name="message"
                                            rules={[{ required: true, message: 'Please enter your message' }]}
                                        >
                                            <Input.TextArea rows={3} placeholder="Your message" />
                                        </Form.Item>
                                    </Col>
                                </Row>
                                <FormItem>
                                    <Button type="primary" htmlType="submit">Submit</Button>
                                </FormItem>
                            </Form>
                        </div>
                    </div>
                </div>

                <div className='main-section-course' style={{ padding: "20px" }}>
                    <div className='course-details-section'>
                        <div className='course-details-text'>
                            {/* <ul className="course-details-description">
                                {Array.isArray(description) ? description.join(" ") : description || ""}
                            </ul> */}
                            <ul style={{ listStyle: "none" }} className="course-details-description">
                                {courseDetails?.course_description?.map((desc: string, idx: number) => (
                                    <li key={idx} dangerouslySetInnerHTML={{ __html: desc }} />
                                ))}
                            </ul>

                        </div>
                        <div className="course-details-image">
                            <img
                                src={courseDetails?.course_certificate_image || defalut}
                                alt=" CFE course Kerala"
                                style={{
                                    height: '400px',
                                    width: '90%',
                                    objectFit: 'contain',
                                }}
                            />
                        </div>


                    </div>

                    <div>
                        <br />
                        <h2 className="homepage-heading">About Certified Fraud Examiner</h2>


                        <div className="course-details-tabs-container">
                            <div className="course-details-tabs">
                                <Tabs
                                    activeKey={activeTab}
                                    onChange={setActiveTab}
                                    type="card"
                                    className="custom-tabs"
                                    items={tabItems}
                                    centered
                                />
                            </div>
                        </div>


                        <Modal
                            title="Check Eligibility"
                            open={isEligibilityModalOpen}
                            onCancel={() => setIsEligibilityModalOpen(false)}
                            footer={null}
                            width={600}
                        >
                            <EligibilityCheckForm
                                courseId={id ? Number(id) : 0}
                                onClose={() => setIsEligibilityModalOpen(false)}
                            />
                        </Modal>
                    </div>

                </div>
                <div className="home-why-wrapper">
                    <div className="home-why-container">
                        <div className="home-why-left">
                            <img src={whycfe} alt=" Fraud examiner course India" className="home-why-image" />
                        </div>
                        <div className="home-why-right">
                            <h2 className="homepage-heading">Why Certified Fraud Examiner?  </h2>
                            <ul className="home-why-list">
                                {whycfetexts.map((text, index) => (
                                    <li key={index} className="home-why-list-item"> {text}</li>
                                ))}
                            </ul>

                        </div>
                    </div>
                </div>
                <div className="home-why-wrapper">
                    <div className="home-why-container">
                        <div className="home-why-left">
                            <h2 className="homepage-heading">Why Meantoir? </h2>
                            <ul className="home-why-list">
                                {whyTexts.map((text, index) => (
                                    <li key={index} className="home-why-list-item"> {text}</li>
                                ))}
                            </ul>
                        </div>
                        <div className="home-why-right">
                            <img src={why1} alt=" Fraud examiner course India" className="home-why-image" />
                        </div>
                    </div>
                </div>
                <div className="ea-section-container">

                    <div>


                        <div style={{ textAlign: "center" }}>
                            <h2 style={{ width: "100%", textAlign: "center", fontSize: "2.5rem", }}>Frequently Asked Questions(FAQ's)</h2>
                        </div>
                        <div >
                            <div>
                                <h3 onClick={() => toggleSection("whatIsEA")} style={{ cursor: "pointer", color: "#007bff", textAlign: "left", fontSize: "1.5rem" }}>
                                    Q1: What is CFE?
                                </h3>
                                {openSection === "whatIsEA" && (
                                    <p style={{ width: "100%", fontSize: "1.5rem", }}>
                                        Certified Fraud Examiner (CFE) is the world’s leading credential in fraud prevention,
                                        detection, and investigation, recognized by banks, corporations, consulting firms, and
                                        government agencies.
                                    </p>
                                )}
                            </div>

                            <div>
                                <h3 onClick={() => toggleSection("whoIsItFor")} style={{ cursor: "pointer", color: "#007bff", textAlign: "left", fontSize: "1.5rem" }}>
                                    Q2: Why choose CFE?
                                </h3>
                                {openSection === "whoIsItFor" && (
                                    <>
                                        <p style={{ fontSize: "1.5rem", }}>
                                            CFE is an AI-proof certification, highly sought after globally, with access to a professional
                                            network of 95,000+ members. It opens doors to high-paying roles in fraud investigation,
                                            auditing, compliance, and forensic accounting.
                                        </p>

                                    </>
                                )}
                            </div>
                            <div>
                                <h3 onClick={() => toggleSection("Howmuch")} style={{ cursor: "pointer", color: "#007bff", textAlign: "left", fontSize: "1.5rem" }}>
                                    Q3: Who can apply for the CFE exam?
                                </h3>
                                {openSection === "Howmuch" && (
                                    <>
                                        <p style={{ fontSize: "1.5rem", }}>
                                            ACFE members who meet the points-based eligibility requirements:
                                            <ul>
                                                <li>Minimum 40 points to sit for the exam </li>
                                                <li>
                                                    50 points + professional experience or approved substitutes to be certified
                                                </li>
                                            </ul>
                                        </p>

                                    </>
                                )}
                            </div>
                            <div>
                                <h3 onClick={() => toggleSection("Whataretheeligibility")} style={{ cursor: "pointer", color: "#007bff", textAlign: "left", fontSize: "1.5rem" }}>
                                    Q4: Is the CFE exam open-book?
                                </h3>
                                {openSection === "Whataretheeligibility" && (
                                    <>
                                        <p style={{ fontSize: "1.5rem", }}>
                                            No, the exam is closed-book and closed-notes.
                                        </p>

                                    </>
                                )}
                            </div>
                            <div>
                                <h3 onClick={() => toggleSection("WhatistestedontheEAexam")} style={{ cursor: "pointer", color: "#007bff", textAlign: "left", fontSize: "1.5rem" }}>
                                    Q5: How long is the exam?
                                </h3>
                                {openSection === "WhatistestedontheEAexam" && (
                                    <>
                                        <p style={{ fontSize: "1.5rem", }}>
                                            Four sections, each timed for 2 hours:                                    </p>
                                        <ol>
                                            <li>Financial Transactions</li>
                                            <li>Law </li>
                                            <li>Fraud Investigation </li>
                                            <li>Fraud Prevention & Deterrence </li>

                                        </ol>

                                    </>
                                )}
                            </div>
                            <div>
                                <h3 onClick={() => toggleSection("Whatistheformatand")} style={{ cursor: "pointer", color: "#007bff", textAlign: "left", fontSize: "1.5rem" }}>
                                    Q6: How much does the exam cost?
                                </h3>
                                {openSection === "Whatistheformatand" && (
                                    <>
                                        <p style={{ fontSize: "1.5rem", }}>
                                            The official fees are around USD $475 for application/exam processing, plus ACFE
                                            membership and any local taxes or vendor fees. Always check ACFE’s official site for current
                                            fees.                                     </p>

                                    </>
                                )}
                            </div>
                            <div>
                                <h3 onClick={() => toggleSection("WheredoItaketheEAexam")} style={{ cursor: "pointer", color: "#007bff", textAlign: "left", fontSize: "1.5rem" }}>
                                    Q7: Where can I take the exam?
                                </h3>
                                {openSection === "WheredoItaketheEAexam" && (
                                    <>
                                        <p style={{ fontSize: "1.5rem", }}>
                                            At ACFE-approved locations, either via remote proctoring or at authorized test centers (e.g.,
                                            Prometric centers worldwide).                                     </p>

                                    </>
                                )}
                            </div>
                            <div>
                                <h3 onClick={() => toggleSection("Howistheexamgraded?")} style={{ cursor: "pointer", color: "#007bff", textAlign: "left", fontSize: "1.5rem" }}>
                                    Q8: Who should take the CFE course?                            </h3>
                                {openSection === "Howistheexamgraded?" && (
                                    <>

                                        <p style={{ fontSize: "1.5rem", }}>
                                            Auditors, accountants, finance professionals, corporate compliance officers, and anyone
                                            aspiring to specialize in fraud detection and prevention.
                                        </p>
                                    </>
                                )}
                            </div>
                            <div>
                                <h3 onClick={() => toggleSection("Arethereanycontinuingeducationrequirements?")} style={{ cursor: "pointer", color: "#007bff", textAlign: "left", fontSize: "1.5rem" }}>
                                    Q9: How long is the course?
                                </h3>
                                {openSection === "Arethereanycontinuingeducationrequirements?" && (
                                    <>
                                        <p style={{ fontSize: "1.5rem", }}>
                                            Typically 3–4 months, depending on pace and preparation.</p>

                                    </>
                                )}
                            </div>
                            <div>
                                <h3 onClick={() => toggleSection("whatarethecareeroppertunitiesincfe")} style={{ cursor: "pointer", color: "#007bff", textAlign: "left", fontSize: "1.5rem" }}>
                                    Q10: What career opportunities are available after CFE?                            </h3>
                                {openSection === "whatarethecareeroppertunitiesincfe" && (
                                    <>
                                        <p style={{ fontSize: "1.5rem", }}>
                                            Fraud investigator, forensic accountant, compliance officer, risk manager, internal auditor,
                                            and global consulting roles.</p>

                                    </>
                                )}
                            </div>
                            <div>
                                <h3 onClick={() => toggleSection("whychoosemeantorforcfe?")} style={{ cursor: "pointer", color: "#007bff", textAlign: "left", fontSize: "1.5rem" }}>
                                    Q11: Why choose Meantoir Global Academy?                            </h3>
                                {openSection === "whychoosemeantorforcfe?" && (
                                    <>
                                        <ul>
                                            <li>Kerala’s first & only CFE exam preparation provider</li>
                                            <li>Lowest training fee in India </li>
                                            <li>Expert faculty & updated study materials </li>
                                            <li>Mock exams and flexible online/offline classes </li>
                                            <li>Full support to become a globally recognized CFE </li>
                                        </ul>
                                    </>
                                )}
                            </div>
                        </div>
                    </div>
                </div>
                <h2 className="homepage-heading">Explore More Courses</h2>
                <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', marginTop: '20px' }}>

                    <CourseDisplayCard />
                </div>

            </div>
            <Footer />
        </div>
    );
}

export default Cfe;
